import { MaintenanceSpecificationDirectiveKlass } from "../types/establishmentLead.type";

export const maintenanceSpecificationDirectiveKlassLabel: Record<MaintenanceSpecificationDirectiveKlass, string> = {
  [MaintenanceSpecificationDirectiveKlass.DiagnosticEntry]: 'Especificações para diagnóstico e orçamento (CM)',
  [MaintenanceSpecificationDirectiveKlass.ExecutionEntry]: 'Especificações de atendimento (CM)',
  [MaintenanceSpecificationDirectiveKlass.ScrapEntry]: 'Especificações para Garantia de Fábrica (CM)',
}
